import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

interface BootstrapValidationForm {
  themePreviewName: FormControl<string | null>;
}

@Component({
  selector: 'app-bootstrap-showcase',
  templateUrl: './bootstrap-showcase.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ReactiveFormsModule, AppErrorMessagesComponent]
})
export class BootstrapShowcaseComponent {
  public validationAttempted = false;

  public validationDemoForm = this.formBuilder.group<BootstrapValidationForm>({
    themePreviewName: this.formBuilder.control('', Validators.required)
  });

  public get formFields() {
    return this.validationDemoForm.controls;
  }

  constructor(private readonly formBuilder: FormBuilder) {}

  public triggerValidationDemo(): void {
    this.validationAttempted = true;
    this.validationDemoForm.markAllAsTouched();
    Object.values(this.validationDemoForm.controls).forEach((control) => {
      control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    });
  }

  public resetValidationDemo(): void {
    this.validationAttempted = false;
    this.validationDemoForm.reset({
      themePreviewName: ''
    });
  }
}
